

export class EmployeeGroupWiseEmployeeOutput implements IEmployeeGroupWiseEmployeeOutput {
    /** The auto-generated id of the employee group wise employee master */
    employee_group_wise_employee_id!: number;
    /** The auto-generated id of the employee details master */
    employee_details_id!: number;
    /** The branch name */
    branch!: string;
    /** The  name of employee with 255 character limit */
    name!: string;
    /** The designation name with 255 character limit */
    designation_name!: string;
    /** The driving experience with 255 character limit */
    driving_experience!: string;
    /** Manage status of user group. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IEmployeeGroupWiseEmployeeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee_group_wise_employee_id = _data["employee_group_wise_employee_id"];
            this.employee_details_id = _data["employee_details_id"];
            this.branch = _data["branch"];
            this.name = _data["name"];
            this.designation_name = _data["designation_name"];
            this.driving_experience = _data["driving_experience"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EmployeeGroupWiseEmployeeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupWiseEmployeeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee_group_wise_employee_id"] = this.employee_group_wise_employee_id;
        data["employee_details_id"] = this.employee_details_id;
        data["branch"] = this.branch;
        data["name"] = this.name;
        data["designation_name"] = this.designation_name;
        data["driving_experience"] = this.driving_experience;
        data["status"] = this.status;
        return data; 
    }
}

export interface IEmployeeGroupWiseEmployeeOutput {
    /** The auto-generated id of the employee group wise employee master */
    employee_group_wise_employee_id: number;
    /** The auto-generated id of the employee details master */
    employee_details_id: number;
    /** The branch name */
    branch: string;
    /** The  name of employee with 255 character limit */
    name: string;
    /** The designation name with 255 character limit */
    designation_name: string;
    /** The driving experience with 255 character limit */
    driving_experience: string;
    /** Manage status of user group. 0 For De-active, 1 For Active */
    status: number;
}

